// extracted by mini-css-extract-plugin
export default {"menuWrapper":"ChartHistorySwitcher-module__menuWrapper","menu":"ChartHistorySwitcher-module__menu","menuItem":"ChartHistorySwitcher-module__menuItem"};